import { useRef, useState, useCallback } from "react";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component

import "ag-grid-community/dist/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/dist/styles/ag-theme-alpine.css"; // Optional theme CSS
import { Button, Box, Text, Flex, Spacer } from "@chakra-ui/react";
import DetailedViewRenderer from "../GenAISearch/DetailedViewRenderer";

const MatchJobProfileGrid = ({ rowData = [] }) => {
  console.log("rowData", rowData)
  const gridRef = useRef();
  const [displayedRowCount, setDisplayedRowCount] = useState(0)
  const [columnDefs] = useState([
    {
      field: "email_id",
      headerName: "Email",
      pinned: "left",
      width: 300,
      resizable: true,
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ["reset", "apply"],
        closeOnApply: true,
      },
    },
    {
      field: "keyword_present",
      headerName: "Keyword Present",
      resizable: true,
      filter: "agNumberColumnFilter",
      filterParams: {
        buttons: ["reset", "apply"],
        closeOnApply: true,
      },
      sortable: true,
      unSortIcon: true,
      valueGetter: (params) => parseInt(params.data.keyword_present)
    },
    {
      field: "matched_skills",
      headerName: "Matched Skills",
      resizable: true,
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ["reset", "apply"],
        closeOnApply: true,
      },
    },
    {
      field: "job_title",
      headerName: "Carrer Titles",
      resizable: true,
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ["reset", "apply"],
        closeOnApply: true,
      },
    },
    { field: "req_id", headerName: "Requisition ID" },
    // { field: "SK", headerName: "Pool name", resizable: true, valueGetter: (param) => param.data.SK.split('__')[0] },
    {
      field: "score_combined",
      headerName: "Score",
      resizable: true,
      filter: "agNumberColumnFilter",
      filterParams: {
        buttons: ["reset", "apply"],
        closeOnApply: true,
      },
      sortable: true,
      valueGetter: (params) => parseInt(params.data.score_combined)
    },
    {
      field: "rank_combined",
      headerName: "Rank",
      resizable: true,
      filter: "agNumberColumnFilter",
      filterParams: {
        buttons: ["reset", "apply"],
        closeOnApply: true,
      },
      sortable: true,
      sort: 'asc'
    },
    {
      field: "score_interpretation",
      headerName: "Score Interpretation",
      resizable: true,
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ["reset", "apply"],
        closeOnApply: true,
      },
    },
  ]);

  const onFilterOpened = useCallback((e) => {
    console.log("onFilterOpened", e);
  }, []);

  const onFilterChanged = useCallback((e) => {
    console.log('ROW COUNT', gridRef.current.api.getDisplayedRowCount());
    setDisplayedRowCount(gridRef.current.api.getDisplayedRowCount())
    console.log("onFilterChanged", e);
    console.log(
      "gridRef.current.api.getFilterModel() =>",
      e.api.getFilterModel()
    );
  }, []);

  const onFilterModified = useCallback((e) => {
    console.log("onFilterModified", e);
    console.log("filterInstance.getModel() =>", e.filterInstance.getModel());
    console.log(
      "filterInstance.getModelFromUi() =>",
      e.filterInstance.getModelFromUi()
    );
  }, []);

  const onDownload = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  const onGridReady = e => {
    console.log(e)
    setDisplayedRowCount(e.api.getDisplayedRowCount())
  }

  return (
    <>
      <Flex minWidth='max-content' width="80vw" alignItems='center' gap='2'>
        <Box mr="2">
          <Text fontSize='sm'>Total Records: {rowData.length}</Text>
        </Box>
        <Box>
          <Text fontSize='sm'>Filtered Records: {displayedRowCount}</Text>
        </Box>
        <Spacer />
        <Button size="sm" onClick={onDownload}>
          Download
        </Button>
      </Flex>
      <div className="ag-theme-alpine" style={{ width: '80vw', height: '60vh' }}>
        <AgGridReact
          onGridReady={onGridReady} // inside onGridReady, you receive the grid APIs if you want them
          ref={gridRef} // Ref for accessing Grid's API
          rowData={rowData} // Row Data for Rows
          columnDefs={columnDefs} // Column Defs for Columns
          // defaultColDef={defaultColDef} // Default Column Properties

          animateRows={true} // Optional - set to 'true' to have rows animate when sorted
          rowSelection="multiple" // Options - allows click selection of rows
          // onCellClicked={cellClickedListener} // Optional - registering for Grid Event
          onFilterOpened={onFilterOpened}
          onFilterChanged={onFilterChanged}
          onFilterModified={onFilterModified}
        />
      </div>
    </>
  );
};

export default MatchJobProfileGrid;
